"use client";
import { useState } from "react";
import { Container } from "react-bootstrap";
import { IoMdNotificationsOutline } from "react-icons/io";
import { IoSearch, IoSettings } from "react-icons/io5";
import { useSelector } from "react-redux";
import classes from "./Header.module.css";
import { profile } from "../../../constant/imagePath";
import { mergeClass } from "../../../resources/utils/helper";
import { useNavigate } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";

export default function Header({
  className,
  toggleDrawer = () => {},
  isMobile = false,
}) {
  const [show, setShow] = useState(false);
  const { user } = useSelector((state) => state.authReducer);
  const navigate = useNavigate();

  return (
    <Container fluid>
      <div className={mergeClass(classes.navbarContainer, className)}>
        <div className={classes.headerTextCont}>
          {isMobile && (
            <GiHamburgerMenu
              className={classes.GiHamburgerMenu}
              onClick={toggleDrawer}
            />
          )}
        </div>
        <div className={classes.imgNameCont}>
          <div className={classes.headerIcons}>
            <div
              className={classes.iconBox}
              onClick={() => navigate("/notification")}
            >
              <IoMdNotificationsOutline size={24} color="#69778E" />
            </div>
          </div>
          <div className={classes.userCont}>
            <div className={classes.avatarImageCont}>
              <img
                src={profile}
                alt="avatar"
                onClick={() => navigate("/profile-setting")}
              />
            </div>
            <p>{user?.name ?? "Jason MT"}</p>
          </div>
        </div>
      </div>
    </Container>
  );
}
